import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DsModal from '../DsModal';
import ResponseStatusEditor from './ResponseStatusEditor';

const Modal = DsModal as React.ComponentType<any>;

export function useResponseStatusQuickMenu() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const openSettingsAfterClose = useRef(false);
  const gesture = useRef({ timer: undefined as ReturnType<typeof setTimeout> | undefined, fired: false, x: 0, y: 0 });
  const cancel = () => clearTimeout(gesture.current.timer);
  useEffect(() => () => clearTimeout(gesture.current.timer), []);
  const longPressProps = {
    onPointerDown: (event: React.PointerEvent) => {
      if (event.button !== 0) return;
      cancel();
      gesture.current.fired = false;
      gesture.current.x = event.clientX; gesture.current.y = event.clientY;
      gesture.current.timer = setTimeout(() => { gesture.current.fired = true; setOpen(true); }, 550);
    },
    onPointerUp: cancel, onPointerCancel: cancel, onPointerLeave: cancel,
    onPointerMove: (event: React.PointerEvent) => { if (Math.hypot(event.clientX - gesture.current.x, event.clientY - gesture.current.y) > 8) cancel(); },
    onClickCapture: (event: React.MouseEvent) => { if (gesture.current.fired) { event.preventDefault(); event.stopPropagation(); gesture.current.fired = false; } },
    onContextMenu: (event: React.MouseEvent) => { event.preventDefault(); cancel(); setOpen(true); },
  };
  const dialog = <ResponseStatusEditor active={open}
    onSaved={() => setOpen(false)}
    onOpenSettings={() => { openSettingsAfterClose.current = true; setOpen(false); }}
    renderLayout={(content, actions) => <Modal open={open} onClose={() => setOpen(false)} onHistoryDismissed={() => {
      if (openSettingsAfterClose.current) { openSettingsAfterClose.current = false; navigate('/admin/settings/work-availability'); }
    }} title="今日のステータス" ariaLabel="今日のステータス" size="sm" footer={actions}>{content}</Modal>}
  />;
  return { longPressProps, openStatus: () => setOpen(true), dialog };
}
